/* es5-ext/string/#/contains/index */ function _(require, module, exports) {
    module.exports = require(340) /* ./is-implemented */()
        ? String.prototype.contains
        : require(341) /* ./shim */;
}
